<template>
  <div class="nettdoc-problems-of-digestion-detail">
    <SectionHeader 
      text="I have problems of digestion" 
      img="illu-card-beschwerden-digestion" 
      alt="intestine for problems of digestion" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.problemsOfDigestionDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when do you have digestion problems?" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['Few hours', '1 day', '2 to 6 days', 'More than one week', '1 month', 'Always']"
        :choice="store.problemsOfDigestionDetails.since"
        v-on:action="value => store.addProblemsOfDigestionDetails('since', value)"
      />

      <SectionHeader text="feelingSick" :dark="true" :required="true" />
      <YesNo
        :model="store.problemsOfDigestionDetails.feelingSick"
        v-on:action="value => store.addProblemsOfDigestionDetails('feelingSick', value)"
      />

      <SectionHeader text="threwUp" :dark="true" :required="true" />
      <YesNo
        :model="store.problemsOfDigestionDetails.threwUp"
        v-on:action="value => store.addProblemsOfDigestionDetails('threwUp', value)"
      />

      <template v-if="store.problemsOfDigestionDetails.threwUp === 'yes'">
        <Dropdown
          label="please choose"
          :data="['Once', 'One to three times', 'More than three times', 'A little bit', 'Suddenly', 'With blood additive']"
          :choice="store.problemsOfDigestionDetails.threwUpType"
          v-on:action="value => store.addProblemsOfDigestionDetails('threwUpType', value)"
        />

      </template>

      <SectionHeader text="diarrhea" :dark="true" :required="true" />
      <YesNo
        :model="store.problemsOfDigestionDetails.diarrhea"
        v-on:action="value => store.addProblemsOfDigestionDetails('diarrhea', value)"
      />

      <template v-if="store.problemsOfDigestionDetails.diarrhea === 'yes'">

        <SectionHeader text="diarrheaCount" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['Once', 'One to three times', 'More than three times']"
          :choice="store.problemsOfDigestionDetails.diarrheaCount"
          v-on:action="value => store.addProblemsOfDigestionDetails('diarrheaCount', value)"
        />

        <SectionHeader text="diarrheaTexture" :dark="true" :required="true" />
        <Dropdown
          label="please choose"
          :data="['Mushy', 'fluid', 'watery']"
          :choice="store.problemsOfDigestionDetails.diarrheaTexture"
          v-on:action="value => store.addProblemsOfDigestionDetails('diarrheaTexture', value)"
        />

      </template>

      <SectionHeader text="bloodyExcrements" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.bloodyExcrements"
        v-on:action="value => store.addProblemsOfDigestionDetails('bloodyExcrements', value)"
      />

      <SectionHeader text="fever" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.fever"
        v-on:action="value => store.addProblemsOfDigestionDetails('fever', value)"
      />

      <SectionHeader text="costiveness" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.costiveness"
        v-on:action="value => store.addProblemsOfDigestionDetails('costiveness', value)"
      />

      <template v-if="store.problemsOfDigestionDetails.costiveness === 'yes'">

        <SectionHeader text="costivenessLastDefecation" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['3 days ago', '5 days ago', 'More than one week ago']"
          :choice="store.problemsOfDigestionDetails.costivenessLastDefecation"
          v-on:action="value => store.addProblemsOfDigestionDetails('costivenessLastDefecation', value)"
        />

        <SectionHeader text="costivenessLiquidAmount" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['Less than one litre per day', '1-2 litres per day', 'More than 2 litres per day']"
          :choice="store.problemsOfDigestionDetails.costivenessLiquidAmount"
          v-on:action="value => store.addProblemsOfDigestionDetails('costivenessLiquidAmount', value)"
        />

      </template>

      <SectionHeader text="lessAppetite" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.lessAppetite"
        v-on:action="value => store.addProblemsOfDigestionDetails('lessAppetite', value)"
      />

      <SectionHeader text="normalAppetite" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.normalAppetite"
        v-on:action="value => store.addProblemsOfDigestionDetails('normalAppetite', value)"
      />

      <SectionHeader text="possibleSpoiledFood" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.possibleSpoiledFood"
        v-on:action="value => store.addProblemsOfDigestionDetails('possibleSpoiledFood', value)"
      />

      <SectionHeader text="nearSurroundingSick" :dark="true" :required="false" />
      <YesNo
        :model="store.problemsOfDigestionDetails.nearSurroundingSick"
        v-on:action="value => store.addProblemsOfDigestionDetails('nearSurroundingSick', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.problemsOfDigestionDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
export default observer({
  name: 'ProblemsOfDigestion',
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown
  },
  methods: {
    submit: function() {
      this.store.problemsOfDigestionDetails.submitted = true
      localStorage.setItem(
        "problemsOfDigestionDetails",
        JSON.stringify(this.store.problemsOfDigestionDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>